import React, { ChangeEvent, FC, useEffect, useRef, useState } from 'react';
import {
  ItemRenderProps,
  SortableItem,
  SortableItemProps,
  SortableList
} from '@thaddeusjiang/react-sortable-list';
import {
  ReOrderableItem,
  ReOrderableList,
  ReOrderableListGroup
} from 'react-reorderable-list-fork';
import MediaCard from './mediaCard';

import { v4 as uuidv4 } from 'uuid';

import ProgressBar from 'react-bootstrap/ProgressBar';
import { Form } from 'react-bootstrap';
import { useTranslate } from '@tolgee/react';
import axios from 'axios';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { useDispatch, useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import {
  getVideoThumbnail,
  isMediaVideo,
  isMediaPdf,
  generateFirebaseUploadUrl,
  isMediaImage
} from '../../../../redux/slices/externalContent/utils';

import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha
} from 'react-google-recaptcha-v3';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUpFromBracket,
  faPhotoFilm,
  faCrop
} from '@fortawesome/pro-duotone-svg-icons';

import toast from 'react-hot-toast';

import { UPLOAD_TYPE_IDEA_MEDIA } from '../../../../config/constants';
import {
  compressImage,
  convertHeicToJpeg,
  getImageDimensions,
  isHeicLikeFile,
  getPdfDimensions,
  getVideoDimensions
} from '../../utils/helpers';

import { externalContentRootState } from '../../../../pages/externalContent';
import {
  addMediaFiles,
  addMediaUploadingFiles,
  clearUnuploadedFiles,
  deleteALoadingfile,
  updateAssetUploadingState,
  updateCancelToken
} from '../../../../redux/slices/externalContent/externalContent';

import TempMediaCard from './temporaryMediaCard';

interface MediaUploadAreaProps {
  sortableListRef: any;
}

const MediaUploadBox: FC<MediaUploadAreaProps> = ({ sortableListRef }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const dispatch = useDispatch();

  const { t } = useTranslate();
  const postData = useSelector(
    (state: externalContentRootState) => state.externalContent.postData
  );

  const allPostData = useSelector(
    (state: externalContentRootState) => state.externalContent.postData
  );

  const postDataMediaFiles = useSelector(
    (state: externalContentRootState) => state.externalContent.postData.media
  );

  const draggedFiles = useSelector(
    (state: externalContentRootState) =>
      state.externalContent?.draggedMediaFiles
  );

  const uploadCancelToken = useSelector(
    (state: externalContentRootState) =>
      state.externalContent?.uploadCancelToken
  );

  const cloud_uuid = useSelector(
    (state: externalContentRootState) => state.externalContent.cloudUuid
  );
  const externalContentConfig = useSelector(
    (state: externalContentRootState) => state.externalContent.externalContentConfig
  );

  const [uploadInProcess, setUploadInProcess] = useState(false);
  const [uploadProcessInPercent, setuploadProcessInPercent] = useState(0);

  const [items, setItems] = useState<SortableItemProps[]>([]);
  const [cropMode, setCropMode] = useState(true);
  const [totalUploadCount, setTotalUploadCount] = useState(0);
  const [currentUploadCount, setCurrentUploadCount] = useState(0);

  useEffect(() => {
    if (Array.isArray(postData.media)) {
      // if (
      //   postData.media.length + postData.mediaUploading.length ===
      //   items.length
      // )
      //   return;

      setItems([
        ...postData.media.map((file: any) => {
          return {
            id: `${file.id}`,
            uuid: file.uuid,
            preview_image: file.preview_image,
            orientation: file.orientation,
            media_type: file.media_type,
            video_duration: file.video_duration,
            uploadPreset: file.uploadPreset,
            file: file.file,
            file_type: file.file_type,
            uploaded: file.uploaded,
            isUploading: file.isUploading,
            assetBlob: file.assetBlob,
            source_media_uuid: file.source_media_uuid,

            previewImageURL: file.previewImageURL,
            thumbnail_image: file.thumbnail_image,
            original_asset: file.original_asset,
            api_url: file?.api_url
          };
        }),
        ...postData.mediaUploading?.map((file: any) => {
          return {
            id: `${file.id}`,
            uuid: file.uuid,
            preview_image: file.preview_image,

            media_type: file.media_type,
            isUploading: file.isUploading,
            file: file.file,
            file_type: file.file_type,

            assetBlob: file.assetBlob
          };
        })
      ]);
    }
  }, [postData.media, postData.mediaUploading, allPostData]);

  const startUpload = () => {
    setuploadProcessInPercent(0);
    setUploadInProcess(true);
  };

  const handleUploadClick = async () => {
    // 👇 We redirect the click event onto the hidden input element
    inputRef.current?.click();
  };

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) {
      return;
    }

    const fileList = e.target.files; // This is a FileList
    const fileArray = Array.from(fileList);

    if (
      Array.isArray(postData.media) &&
      postData.media?.length + postData.mediaUploading?.length < 11
    ) {
      const currentCount =
        10 - (postData.media?.length + postData.mediaUploading?.length);
      currentCount > -1
        ? uploadAssets(fileArray.slice(0, currentCount))
        : toast.error(`${t('externalContent.errors.max_limit_reached')}`, {
            duration: 4000,
            position: 'top-right'
          });
    } else {
      toast.error(`${t('externalContent.errors.max_limit_reached')}`, {
        duration: 4000,
        position: 'top-right'
      });

      console.error(`Maximum limit (${10}) reached!`, postData.media?.length);
    }
  };
  const handleDraggedFileChange = async (files: any[]) => {
    if (!files) {
      return;
    }

    // TODO: Check if file upload is ok

    // 🚩 do the file upload here normally...

    const fileList = files; // This is a FileList
    const fileArray = Array.from(fileList);
    uploadAssets(fileArray);
  };

  const uploadAssets = async (fileArray) => {
    const prevUploadedFiles = postDataMediaFiles.map((item) => item?.file);

    const total_file_array = [...prevUploadedFiles, ...fileArray];
    const is_valid = true;

    if (!is_valid) {
      return;
    }

    setCurrentUploadCount(0);
    setTotalUploadCount(fileArray.length);

    await dispatch(
      updateAssetUploadingState({
        state: true
      })
    );

    startUpload();
    const filesWithPreview = await Promise.all(
      fileArray.map(async (file) => {
        if (isHeicLikeFile(file)) {
          try {
            const jpegFile = await convertHeicToJpeg(file);
            console.log('Converted JPEG URL:', jpegFile);
            file = jpegFile;
          } catch (error) {
            console.error('Conversion error:', error);
          }
        }
        if (isMediaImage(file)) {
          if (file) {
            try {
              const compressedFile = await compressImage(file);

              file = compressedFile;
            } catch (error) {
              console.error('Compression error:', error);
            }
          } else {
            console.log('Please upload a valid image file.');
          }
        }

        let preview_image: any = URL.createObjectURL(file);
        let dimensions;

        let assetBlob: any = URL.createObjectURL(file);
        const file_type = file.type;
        const fileSizeInBytes = file.size;
        let media_type = 'image';
        let video_duration = null;
        let uploadPreset;
        let source_media_uuid = null;

        const temporaryUuid = uuidv4();

        dispatch(
          addMediaUploadingFiles({
            files: [
              {
                id: temporaryUuid,
                uuid: temporaryUuid,
                name: `${file.name}`,
                file: file,
                preview_image: isMediaVideo(file)
                  ? await getVideoThumbnail(file)
                  : preview_image,
                media_type: isMediaImage(file)
                  ? 'image'
                  : isMediaVideo(file)
                  ? 'video'
                  : isMediaPdf(file)
                  ? 'doc'
                  : 'image',
                isUploading: true,

                file_type: file_type,
                assetBlob: assetBlob
              }
            ]
          })
        );

        const orientation = await getFileOrientation(file)
          .then((orientation) => {
            if (orientation !== null) {
              console.log('Orientation or aspect ratio:', orientation);
              return orientation;
            } else {
              const file_type =
                file.type.split('/')[0] === 'application'
                  ? file.type.split('/')[1]
                  : file.type.split('/')[0];

              if (file_type === 'image' || file_type === 'video') {
                setTotalUploadCount(0);
                setCurrentUploadCount(0);

                throw new Error(`${t('externalContent.file_rejected')}`);
              }

              console.log('Unable to determine orientation or aspect ratio.');
              return null;
            }
          })
          .catch((error) => {
            console.error('Error reading file:', error);
            return null;
          });

        if (isMediaImage(file)) {
          dimensions = await getImageDimensions(preview_image);
          const recaptchaToken = await executeRecaptcha('uploadAssets');

          uploadPreset = await generateFirebaseUploadUrl(
            {
              recaptcha: recaptchaToken,
              content_type: file_type,
              filesize_in_bytes: fileSizeInBytes,
              filename: file.name,
              ...(externalContentConfig?.upload_context || {
                cloud_uuid: cloud_uuid
              }),
              width: dimensions?.width,
              height: dimensions?.height,
              upload_type: UPLOAD_TYPE_IDEA_MEDIA
            },
            {},
            () => {
              console.log('error here');
              toast.error(`${t('errors.unableToGeneratePresets')}`, {
                duration: 4000,
                position: 'top-right'
              });
            },
            () => console.log('success here'),
            recaptchaToken
          );
        }

        if (isMediaVideo(file)) {
          dimensions = await getVideoDimensions(file);

          media_type = 'video';
          try {
            video_duration = await getVideoDuration(file);
          } catch (error) {
            console.error('Failed to get video duration:', error);
          }

          const fileBuffer = await readFileAsArrayBuffer(file);
          const numberOfChannels = await getNumberOfAudioChannels(fileBuffer);
          console.log('Number of channels:', numberOfChannels);
          preview_image = await getVideoThumbnail(file);
          const recaptchaToken = await executeRecaptcha('uploadAssets');
          uploadPreset = await generateFirebaseUploadUrl(
            {
              recaptcha: recaptchaToken,
              content_type: file_type,
              filesize_in_bytes: fileSizeInBytes,
              filename: file.name,
              ...(externalContentConfig?.upload_context || {
                cloud_uuid: cloud_uuid
              }),
              width: dimensions?.width,
              height: dimensions?.height,
              duration_in_ms: video_duration,
              upload_type: UPLOAD_TYPE_IDEA_MEDIA
            },
            {},
            () => {
              console.log('error here');
              toast.error(`${t('errors.unableToGeneratePresets')}`, {
                duration: 4000,
                position: 'top-right'
              });
            },
            () => console.log('success here'),
            recaptchaToken
          );
        }
        if (isMediaPdf(file)) {
          media_type = 'doc';
          dimensions = await getPdfDimensions(file);

          const recaptchaToken = await executeRecaptcha('uploadAssets');
          uploadPreset = await generateFirebaseUploadUrl(
            {
              recaptcha: recaptchaToken,
              content_type: file_type,
              filesize_in_bytes: fileSizeInBytes,
              filename: file.name,
              ...(externalContentConfig?.upload_context || {
                cloud_uuid: cloud_uuid
              }),
              width: dimensions?.width,
              height: dimensions?.height,
              upload_type: UPLOAD_TYPE_IDEA_MEDIA
            },
            {},
            () => {
              console.log('error here');
              toast.error(`${t('errors.unableToGeneratePresets')}`, {
                duration: 4000,
                position: 'top-right'
              });
            },
            () => console.log('success here'),
            recaptchaToken
          );
        }

        return {
          file,
          preview_image,
          media_type,
          video_duration,
          orientation,
          fileSizeInBytes,
          uploadPreset,
          file_type,
          assetBlob,
          source_media_uuid,
          temporaryUuid
        };
      })
    );

    if (postData) {
      dispatch(
        addMediaFiles({
          files: filesWithPreview
            .map((file) => {
              dispatch(
                deleteALoadingfile({
                  fileID: file.temporaryUuid
                })
              );

              if (file?.uploadPreset) {
                return {
                  id: file.uploadPreset?.uuid,
                  uuid: file.uploadPreset?.uuid,
                  name: `${file.file.name}`,
                  file: file.file,
                  preview_image: file.preview_image,
                  orientation: file.orientation,
                  media_type: file.media_type,
                  video_duration: file.video_duration,
                  file_size: file.fileSizeInBytes,
                  uploadPreset: file.uploadPreset,
                  file_type: file.file_type,
                  assetBlob: file.assetBlob,
                  source_media_uuid: file.source_media_uuid,
                  uploaded: false,
                  isUploading: true,
                  editorUpdateState: true,
                  previewImageURL:
                    file.uploadPreset?.uploaded_object_data.preview_image_url,
                  thumbnail_image: file.uploadPreset?.thumbnail_url,
                  original_asset:
                    file.uploadPreset?.uploaded_object_data.original_asset,
                  api_url: file.uploadPreset?.uploaded_object_data?.api_url
                };
              } else {
                return null;
              }
            })
            .filter((file) => file !== null)
        })
      );
    }

    inputRef.current.value = '';
  };

  const readFileAsArrayBuffer = (file: File): Promise<ArrayBuffer> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target && event.target.result instanceof ArrayBuffer) {
          resolve(event.target.result);
        } else {
          reject(new Error('Failed to read file as ArrayBuffer'));
        }
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const getNumberOfAudioChannels = (
    fileBuffer: ArrayBuffer
  ): Promise<number> => {
    return new Promise((resolve, reject) => {
      const audioContext = new AudioContext();
      try {
        audioContext.decodeAudioData(
          fileBuffer,
          (audioBuffer) => {
            resolve(audioBuffer?.numberOfChannels);
          },
          (error) => {
            console.log(error);
            resolve(null);
          }
        );
      } catch (error) {
        console.log('unable to determine', error);
        reject(error);
      }
    });
  };

  const getVideoDuration = async (file: File): Promise<number | null> => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        resolve(Math.round(video.duration * 1000)); // Convert to milliseconds
      };

      video.onerror = () => {
        reject('Failed to load video');
      };

      video.src = URL.createObjectURL(file);
    });
  };
  function getFileOrientation(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          let orientation;
          if (img.width > 0 && img.height > 0) {
            if (img.width > img.height) {
              orientation = 'landscape';
            } else if (img.height > img.width) {
              orientation = 'portrait';
            } else {
              orientation = 'square';
            }
            resolve(orientation);
          } else {
            // Image dimensions are 0, might not be an image
            resolve(null);
          }
        };
        img.onerror = () => {
          // Error loading image, might not be an image
          resolve(null);
        };
        img.src = event.target.result as string; // Explicit cast to string
      };
      reader.onerror = () => {
        // Error reading file, can't determine orientation
        resolve(null);
      };

      if (file.type.startsWith('image')) {
        reader.readAsDataURL(file);
      } else if (file.type.startsWith('video')) {
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.onloadedmetadata = () => {
          const aspectRatio = video.videoWidth / video.videoHeight;

          let orientation;
          if (video.videoWidth > 0 && video.videoHeight > 0) {
            if (aspectRatio > 1) {
              orientation = 'landscape';
            } else if (aspectRatio < 1) {
              orientation = 'portrait';
            } else {
              orientation = 'square';
            }
            resolve(orientation);
          } else {
            // Image dimensions are 0, might not be an image
            resolve(null);
          }
        };
        video.onerror = () => {
          // Error loading video, can't determine aspect ratio
          resolve(null);
        };
        video.src = URL.createObjectURL(file);
      } else {
        // Unsupported file type, can't determine orientation
        resolve(null);
      }
    });
  }

  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  const cancelRequest = async () => {
    uploadCancelToken.cancel('Operation canceled by the user.');

    dispatch(clearUnuploadedFiles());
    dispatch(
      updateAssetUploadingState({
        state: false
      })
    );

    setTimeout(() => {
      dispatch(
        updateCancelToken({
          token: null
        })
      );
    }, 2000);
  };

  useEffect(() => {
    if (draggedFiles.length > 0) {
      handleDraggedFileChange(draggedFiles);
    }
  }, [draggedFiles]);

  return (
    <div key={`media_upload_area`} className={'mb-3'}>
      <div
        style={{ overflowX: 'hidden', position: 'relative' }}
        className={
          'd-flex flex-column rounded bg-secondary bg-opacity-25 px-5 user-select-none'
        }
      >
        <div className="h-20px w-100"></div>
        <div
          style={{ zIndex: 2, position: 'relative' }}
          className={'d-flex flex-row gap-1'}
        >
          <div
            onClick={handleUploadClick}
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              zIndex: 1
            }}
          ></div>
          {items?.length === 0 ? (
            <div
              style={{ rowGap: '3px' }}
              className="w-100 d-flex flex-column text-muted"
            >
              <div
                onClick={handleUploadClick}
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  zIndex: 1
                }}
              ></div>
              <div className="text-center fw-bold py-1">
                {t('externalContent.dragAndDrop')}
              </div>
              <div className="text-center d-flex justify-content-center py-1">
                {t('externalContent.or')}
              </div>

              <div
                style={{ zIndex: 2 }}
                className="d-flex flex-row align-items-center justify-content-center gap-2 pt-1 w-100 "
              >
                <button
                  style={{ minWidth: '35%' }}
                  onClick={handleUploadClick}
                  type="button"
                  className="btn btn-white btn-sm pl-4"
                >
                  <span>
                    <i className="fa-solid fa-arrow-up-from-bracket"></i>
                  </span>{' '}
                  <span className="text-muted fw-bolder">
                    {t('externalContent.uploadFile')}
                  </span>
                </button>
              </div>
            </div>
          ) : (
            <div
              style={{
                zIndex: 2,
                display: 'flex',
                flexWrap: 'wrap',
                width: '100%',
                overflowY: 'scroll'
              }}
              ref={sortableListRef}
            >
              <ReOrderableList
                name="uniqueGroupName"
                list={items}
                //the list update callback
                onListUpdate={(newList) => setItems(newList)}
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  width: '100%'
                }}
              >
                {items.map((item, index) => {
                  const content =
                    item?.uploadPreset || item?.uploaded ? (
                      <MediaCard
                        key={item?.id}
                        item={item}
                        setUploadCount={setCurrentUploadCount}
                        setTotalUploadCount={setTotalUploadCount}
                      ></MediaCard>
                    ) : (
                      <TempMediaCard
                        key={item?.id}
                        item={item}
                        setUploadCount={setCurrentUploadCount}
                        setTotalUploadCount={setTotalUploadCount}
                      ></TempMediaCard>
                    );

                  return items?.some((obj) => obj?.isUploading === true) ? (
                    <div key={`item-${index}`}>{content}</div>
                  ) : (
                    <ReOrderableItem key={`item-${index}`}>
                      {content}
                    </ReOrderableItem>
                  );
                })}

                <div
                  className={
                    'img-thumbnail m-1 h-100px w-100px bg-secondary d-flex justify-content-center align-items-center cursor-pointer'
                  }
                  onClick={handleUploadClick}
                >
                  <i
                    style={{ fontSize: '32px' }}
                    className="fa-duotone fa-plus-large"
                  ></i>
                </div>
              </ReOrderableList>

              {/* <SortableList items={items} setItems={setItems}>
                {({ items }: { items: SortableItemProps[] }) => {
                  return (
                    <>
                      {items.map((item: SortableItemProps) => {
                        if (item?.uploadPreset) {
                          return (
                            <MediaCard
                              key={item?.id}
                              item={item}
                              setUploadCount={setCurrentUploadCount}
                              setTotalUploadCount={setTotalUploadCount}
                            ></MediaCard>
                          );
                        } else {
                          return (
                            <TempMediaCard
                              key={item?.id}
                              item={item}
                              setUploadCount={setCurrentUploadCount}
                              setTotalUploadCount={setTotalUploadCount}
                            ></TempMediaCard>
                          );
                        }
                      })}
                    </>
                  );
                }}
              </SortableList> */}
            </div>
          )}
        </div>

        <div className={'d-flex flex-row justify-content-end'}>
          <input
            type="file"
            ref={inputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
            multiple={true}
            accept=".jpeg, .jpg, .png, .mov, .mp4, .pdf, .heic, .heif"
            max={3}
          />
        </div>

        <div className="h-20px w-100">
          {postDataMediaFiles?.some((obj) => obj?.isUploading === true) && (
            <div className="d-flex flex-row align-items-center justify-content-start gap-2 flex-fill">
              <span
                className="spinner-border spinner-border-sm me-1 fs-4 "
                role="status"
                aria-hidden="true"
                style={{ width: '16px', height: '16px' }}
              ></span>
              <div
                style={{ padding: '2px 4px 2px 4px' }}
                className="text-muted fw-bolder cursor-pointer"
                onClick={cancelRequest}
              >
                {t('externalContent.buttons.cancel')}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="d-flex flex-row align-items-start gap-2 mt-1">
        <div className="d-flex flex-row align-items-start justify-content-end gap-2 w-100 flex-wrap flex-fill">
          <div className="text-muted">
            {t('externalContent.text.max_10_files')}
          </div>
          {/* <div className="d-flex flex-row align-items-start justify-content-end gap-2 mt-1">
            <FontAwesomeIcon
              size="lg"
              color={cropMode ? "#0d6efd" : "#6c757d"}
              icon={faCrop}
            />
            <Form.Check
              type="switch"
              id="use-seperate-media-files-switch"
              className="cursor-pointer"
              checked={cropMode}
              onChange={() => setCropMode((prevState) => !prevState)}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default MediaUploadBox;
